function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.218 8.924a13.42 13.42 0 005.858 5.858l1.955-1.955a.892.892 0 01.907-.223c.995.33 2.062.507 3.173.507.491 0 .889.398.889.889v3.111a.889.889 0 01-.889.889C8.765 18 2 11.235 2 2.889A.889.889 0 012.889 2H6a.89.89 0 01.889.889c0 1.111.178 2.178.507 3.173a.892.892 0 01-.223.907L5.218 8.924z",
  fill: "#74808F"
});
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 1 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.4e4ba56d.svg";
export { ForwardRef as ReactComponent };